import Client from "../client";
import BasicRepository from "../repositories/basicRepository";
import {AuthenticationResource} from "./authenticationResource";
import {LoginInitiatedResource} from "./loginInitiatedResource";

class AuthenticationRepository extends BasicRepository<AuthenticationResource, AuthenticationResource> {
    constructor(client: Client) {
        super("Authentication", client);
    }
    get(): Promise<AuthenticationResource> {
        return this.client.get<AuthenticationResource>(this.client.getRootDocument().Links["Authentication"]);
    }

    wasLoginInitiated(encodedQueryString: string): Promise<LoginInitiatedResource> {
        return this.client.post<LoginInitiatedResource>(this.client.getRootDocument().Links["LoginInitiated"], { EncodedQueryString: encodedQueryString });
    }
}

export default AuthenticationRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/authentication/authenticationRepository.ts